import styled from 'styled-components'

import { Typography } from 'components/Typography/Typography'

export const TableContainer = styled.div`
  padding-top: 0px;
  padding-bottom: 16px;
  margin-top: 32px;
  border-radius: 16px;
  border: 0.7px solid ${p => p.theme.colors.divider};
  background: ${p => p.theme.colors.background.primary};
  box-shadow: 0px 0px 16px 0px ${p => p.theme.colors.background.hover};
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    padding: 16px 0;
  }
`
export const Th = styled(Typography)<{ $disabled: boolean }>`
  flex-basis: 200px;
  cursor: pointer;
  display: flex;
  align-items: center;
  & > div {
    display: flex;
    align-items: center;
  }
  & > div > svg {
    margin-left: 8px;
    & > path {
      stroke: ${p => p.theme.colors.text.primary};
    }
  }
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    font-size: ${p => p.theme.typography.size.Body}px;
  }

  ${p =>
    p.$disabled &&
    `
    opacity: 0.5;
    pointer-events: none;
    `}
`

export const IconNextContainer = styled.div`
  display: flex;
  position: absolute;
  right: 24px;
  cursor: pointer;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    right: 16px;
  }
`

export const IconCloneContainer = styled.div`
  display: flex;
  position: absolute;
  right: 8px;
  cursor: pointer;

  div {
    display: flex;
  }

  a {
    display: flex;
  }
`

export const RowWrapper = styled.div<{ $isLast?: boolean; $hideHover?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: ${p => (p.$hideHover ? 'auto' : 'pointer')};
  padding: 0 24px;
  border-bottom: ${p => (p.$isLast ? 'none' : `1px solid ${p.theme.colors.divider}`)};
  ${p =>
    !p.$hideHover &&
    `
      &:hover {
    background-color: ${p.theme.colors.background.active};
    & > div:last-child > svg > rect {
      fill: ${p.theme.colors.button.background};
    }
    & > div:last-child > svg > path {
      stroke: ${p.theme.colors.background.primary};
    }
  }
    `}
`

export const Td = styled(Typography)`
  flex-basis: 200px;
  overflow: hidden;
  height: 64px;
  display: flex;
  align-items: center;

  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    display: block;
    & > div {
      font-size: ${p => p.theme.typography.size.Caption1}px;
    }
    height: auto;
  }

  a {
    color: ${p => p.theme.colors.text.primary};
  }
`

export const HeaderContainer = styled.div`
  padding: 16px 24px;
  display: flex;
  border-bottom: 1px solid ${p => p.theme.colors.divider};
  gap: 20px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    display: none;
  }
`
